<template>
  <HeaderContent title="InHouse Lists" />
  <!-- <ActionContent :filterDate="false" :cta="false" /> -->
  <ActionContent
    :cta="false"
    :filter-modal="false"
    @action="modal = !modal"
    @showFilter="modalFilter = !modalFilter"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    v-model:search="search"
    @search-query="handleSearch"
  />
  <ExtrachargeForm
    :modal="modalExtraCharge"
    :uuid="reservationUuid"
    :from="from"
    @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="getAll"
  />
  <InhouseStatistics title="In House Statistics" :data="statistics" />
  <InhouseDataTable
    :data="inhouses"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
  <InhouseFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
    @filter="handleFilter"
  />
  <InHouseForm :modal="modal" @update:modal="modal = $event" />
  <PaymentForm
    :modal="modalPayment"
    :uuid="reservationUuid"
    @update:modal="modalPayment = $event"
    @paid="handlePayment"
  />
  <CheckOutConfirm
    title="Check Out Confirmation"
    :uuid="reservationUuid"
    :data="guestInformation"
    :actionType="actionType"
    :modalConfirm="modalEarlyCheckOut"
    v-model="modalEarlyCheckOut"
    @confirmed="handleEarlyCheckout"
  >
    <template #body>
      <div class="guest-info text-start">
        <div>
          <!-- informasi tamu -->
          <div class="px-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Guest Information</p>
            <ul class="guest">
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">ID/Pasport</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.guest?.identity_number ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Name</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation.reservation?.guest?.fullname ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Contact</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold"
                  >0{{
                    guestInformation.reservation?.guest?.phone ?? "-"
                  }}</span
                >
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Check In</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(guestInformation?.check_in_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Check Out</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(guestInformation?.check_out_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold label">Stay Duration</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  countDays(
                    guestInformation?.check_in_date,
                    guestInformation?.check_out_date
                  )
                }}</span>
              </li>
            </ul>
          </div>

          <!-- Detail Tagihan -->
          <div class="p-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Billing Details</p>
            <ul class="billing">
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Type</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.room?.room_category?.name ??
                  "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Number</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.room?.code ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Room Rate</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(
                    guestInformation?.reservation?.room?.room_category
                      ?.low_season_price ?? 0
                  )
                }}</span>
              </li>
              <li class="mb-1" style="list-style: none">
                <div class="d-flex gap-2 align-items-start">
                  <span class="fw-semibold">Extra Charge</span>
                  <span class="fw-semibold label">:</span>
                  <div class="extra-charges">
                    <div
                      v-if="
                        guestInformation?.reservation?.extracharge?.length === 0
                      "
                      class="fw-semibold"
                    >
                      -
                    </div>
                    <div
                      v-for="(item, index) in guestInformation?.reservation
                        ?.extracharge ?? []"
                      :key="index"
                      class="extra-charge-item fw-semibold"
                    >
                      {{ item?.extra_charge?.name }} (Qty: {{ item?.quantity }},
                      {{ formatIDR(item?.extra_charge?.price ?? 0) }})
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb-1" style="list-style: none">
                <div class="d-flex gap-2 align-items-start">
                  <span class="fw-semibold">Payment</span>
                  <span class="fw-semibold label">:</span>
                  <div class="payments">
                    <div
                      v-if="
                        guestInformation?.reservation?.payment?.length === 0
                      "
                      class="fw-semibold"
                    >
                      -
                    </div>
                    <div
                      v-for="(item, index) in guestInformation?.reservation
                        ?.payment ?? []"
                      :key="index"
                      class="payment-item fw-semibold"
                    >
                      {{ item?.payment_type }} (Date:
                      {{ dateFormatter(item?.payment_date) }},
                      {{ formatIDR(item?.amount ?? 0) }})
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Total Payment</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(guestInformation?.reservation?.total_paid ?? 0)
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Payment Status</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  guestInformation?.reservation?.payment_status ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Outstanding Balance</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(
                    guestInformation?.reservation?.outstanding_balance ?? 0
                  )
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </CheckOutConfirm>

  <BillResto
    title="Bill Resto"
    :uuid="reservationUuid"
    v-model="modalBillResto"
  />

  <FormMaintenance
    v-if="modalMaintenance"
    v-model="modalMaintenance"
    :data="dataMaintenance"
  ></FormMaintenance>

  <ExtendForm
    :modal="modalExtend"
    :item="dataExtend"
    @update:modal="modalExtend = $event"
    @addOrUpdate="getAll"
  ></ExtendForm>

  <ToastResponse
    v-model="toastResponse.toast"
    :text="toastResponse.text"
    :success="toastResponse.success"
  ></ToastResponse>
</template>

<script>
import { ref, inject, onMounted, watch, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import InhouseStatistics from "@/components/StatisticData.vue";
import InhouseFilter from "./InHouseFilter.vue";
import InHouseForm from "./InHouseForm.vue";
import InhouseDataTable from "@/components/DataTable.vue";
import iconInHouse from "../../../public/icons/home-location.svg";
// import iconDeluxe from "../../../public/icons/business-value.svg";
// import iconStudio from "../../../public/icons/space-station-moon.svg";
// import iconHoneymoon from "../../../public/icons/rings-wedding.svg";
// import iconFamily from "../../../public/icons/family-pants.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import CheckOutConfirm from "@/components/ModalDialog.vue";
import BillResto from "@/components/BillResto.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import FormMaintenance from "../room/FormMaintenance/FormMaintenance.vue";
import ExtendForm from "@/components/Extend/ExtendForm.vue";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

export default {
  components: {
    HeaderContent,
    ActionContent,
    InhouseFilter,
    InHouseForm,
    InhouseStatistics,
    InhouseDataTable,
    ExtrachargeForm,
    CheckOutConfirm,
    BillResto,
    PaymentForm,
    ToastResponse,
    FormMaintenance,
    ExtendForm,
  },
  setup() {
    const repositories = inject("repositories");
    const inhouseRepository = repositories?.inhouse;
    const checkinRepository = repositories?.checkin;
    const modal = ref(false);
    const modalExtraCharge = ref(false);
    const modalPayment = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalEarlyCheckOut = ref(false);
    const actionType = ref("");

    const reservationUuid = ref(null);
    const currentPage = ref(1);
    //const inHouseData = ref(null);
    const inhouse = ref({});
    const inhouses = ref([]);
    const data = ref([]);
    const guestInformation = ref({});

    const from = ref("inhouse");

    const modalMaintenance = ref(false);
    const dataMaintenance = ref({});

    const modalExtend = ref(false);
    const dataExtend = ref(null);
    const modalBillResto = ref(false);

    const openExtendForm = (row) => {
      dataExtend.value = null;
      nextTick(() => {
        dataExtend.value = row;
        modalExtend.value = true;
      });
    };

    const toastResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "is_online",
        label: "",
        class: "text-center w-25",
        tdClass: "align-middle",
      },
      {
        key: "room_category",
        label: "Room Type",
        class: "text-center",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "reservation.room.code",
        label: "Room Number",
        class: "text-center",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "reservation.guest.fullname",
        label: "Guest Name",
        tdClass: " align-middle",
        sortable: true,
      },
      {
        key: "check_in_date",
        label: "Check In",
        class: "text-left",
        tdClass: " align-middle",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "check_out_date",
        label: "Check Out",
        tdClass: " align-middle",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "day_left",
        label: "Days Left",
        class: "text-center",
        tdClass: " align-middle",
        sortable: true,
      },

      {
        key: "action",
        label: "Actions",
        tdClass: " align-middle",
      },
    ]);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);
    const search = ref("");
    const filterStatus = ref({
      status: null,
    });

    const statistics = ref([]);

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = ""
    ) => {
      const params = {};

      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.status = status;
      if (searchQuery) params.search = searchQuery;

      try {
        const res = await checkinRepository.getListInhouse(params);

        inhouses.value = res.data.data;
        const inHouseStatistics = res.data.statistics;

        statistics.value = Object.entries(inHouseStatistics).map(
          ([key, value]) => {
            return {
              label: "Total",
              key: key
                .replace("_", " ")
                .replace(/\b\w/g, (l) => l.toUpperCase()),
              value,
              color: key === "in_house" ? "success" : "primary",
              icon: iconInHouse,
            };
          }
        );
      } catch (err) {
        console.error(err);
      }
    };

    const getById = async (uuid) => {
      await inhouseRepository
        .getById(uuid)
        .then((res) => {
          modal.value = true;
          inhouse.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const customActions = ref([
      {
        label: "Add ExtraCharge",
        variant: "warning",
        icon: "fas fa-bolt",
        action: (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalExtraCharge.value = true;
        },
      },
      {
        label: "Order",
        variant: "primary",
        icon: "fas fa-utensils",
        action: async (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalBillResto.value = true;
        },
      },
      {
        label: "Set Maintenance",
        variant: "danger",
        icon: "fas fa-wrench",
        action: (item) => {
          dataMaintenance.value = { item };
          modalMaintenance.value = true;
        },
      },
      {
        label: "More Options",
        variant: "secondary",
        icon: "fas fa-caret-square-down", // atau icon dropdown
        isDropdown: true,
        actions: [
          {
            label: "Extend Stay",
            icon: "fas fa-calendar-plus",
            action: (item) => {
              openExtendForm(item);
            },
          },
          {
            label: "Early Checkout",
            icon: "fas fa-sign-out-alt",
            action: (item) => {
              reservationUuid.value = item.reservation.uuid;
              guestInformation.value = item;

              if (item.reservation.is_paid) {
                actionType.value = "early-checkout";
                modalEarlyCheckOut.value = true;
              } else {
                modalPayment.value = true;
              }
            },
          },
        ],
      },
    ]);

    const refreshGuestInfo = async (uuid) => {
      try {
        await getAll(); // Refresh semua data in-house dari server

        const updatedGuest = inhouses.value.find(
          (item) => item.reservation?.uuid === uuid
        );

        if (updatedGuest) {
          guestInformation.value = { ...updatedGuest };
        } else {
          console.warn("Guest with UUID not found after refresh:", uuid);
        }
      } catch (err) {
        console.error("Error refreshing guest info:", err);
      }
    };

    const handlePayment = async () => {
      await refreshGuestInfo(reservationUuid.value);
      modalPayment.value = false;
      if (guestInformation.value.reservation.is_paid) {
        modalEarlyCheckOut.value = true;
      }
    };

    const handleEarlyCheckout = (actionType) => {
      if (actionType.type === "early-checkout") {
        setCheckout(actionType.uuid);
      }
    };

    const setCheckout = async (uuid) => {
      try {
        await checkinRepository.checkOut(uuid).then((response) => {
          getAll();
          modalEarlyCheckOut.value = false;

          toastResponse.value = {
            toast: true,
            success: true,
            text: response?.data?.message || "Guest checked out successfully",
          };
        });
      } catch (e) {
        console.log(e);

        toastResponse.value = {
          toast: true,
          success: false,
          text: e.response?.data?.error || "Something went wrong!",
        };
      }
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    const handleSearch = (query) => {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    };

    // const updateModal = (value) => {
    //   modalExtend.value = value;
    //  dataExtend.value = {}
    // };

    watch([startDate, endDate, filterStatus, search], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });

    onMounted(() => {
      getAll();
    });

    return {
      getAll,
      getById,
      filterStatus,
      handleFilter,
      handleSearch,
      handleEarlyCheckout,
      handlePayment,
      search,
      getCurrentDate,
      startDate,
      endDate,
      reservationUuid,
      modal,
      modalPayment,
      modalEarlyCheckOut,
      modalExtraCharge,
      modalFilter,
      modalConfirm,
      modalBillResto,
      guestInformation,
      refreshGuestInfo,
      data,
      from,
      headers,
      statistics,
      inhouse,
      inhouses,
      currentPage,
      customActions,
      actionType,
      formatIDR,
      dateFormatter,
      countDays,
      toastResponse,
      modalMaintenance,
      dataMaintenance,
      modalExtend,
      dataExtend,
    };
  },
};
</script>

<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.payments {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.payment-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #00f974;
}
</style>
